export enum TRANSACTION_PROCESSING_ACTION {
  VIEW_DETAIL = 'VIEW_DETAIL',
  EDIT_TRANSACTION = 'EDIT_TRANSACTION',
  VOID_TRANSACTION = 'VOID_TRANSACTION',
  MOVE_TRANSACTION = 'MOVE_TRANSACTION',
  SPLIT_TRANSACTIONS = 'SPLIT_TRANSACTIONS',
  UNDO_VOIDED = 'UNDO_VOIDED'
}
